import { VCData } from "../types/vc";
import { GraphData, GraphNode, GraphLink } from "../types/graph";

const COLORS = {
  vc: "#60A5FA", // Soft blue - clean and modern
  team: "#C084FC", // Soft purple - elegant
  portfolio: "#34D399", // Soft emerald - fresh and clean
  founder: "#F472B6", // Soft pink - gentle accent
};

export function transformVCToGraph(vcData: VCData): GraphData {
  const nodes: GraphNode[] = [];
  const links: GraphLink[] = [];

  // Add VC node
  nodes.push({
    id: vcData.uuid,
    name: vcData.name,
    type: "vc",
    image: vcData.logo || vcData.data?.imageUrl,
    size: 20,
    color: COLORS.vc,
  });

  // Add team members
  if (vcData.bdRaw.current_employees) {
    vcData.bdRaw.current_employees.forEach((member) => {
      const memberId = `team-${member.name}`;
      nodes.push({
        id: memberId,
        name: member.name,
        type: "team",
        image: member.image || "https://www.gravatar.com/avatar/?d=mp",
        size: 10,
        color: COLORS.team,
      });
      links.push({
        source: vcData.uuid,
        target: memberId,
        type: "team",
      });
    });
  }

  // Add portfolio companies and their founders
  if (vcData.portfolio) {
    vcData.portfolio.forEach((company) => {
      // Add portfolio company node
      nodes.push({
        id: company.uuid,
        name: company.name,
        type: "portfolio",
        image: company.logo || company.data?.imageUrl,
        size: 15,
        color: COLORS.portfolio,
      });
      links.push({
        source: vcData.uuid,
        target: company.uuid,
        type: "portfolio",
      });

      // Add founders if available
      if (company.bdRaw.founders) {
        company.bdRaw.founders.forEach((founder) => {
          const founderId = `founder-${founder.id}`;
          const founderImage = company.bdRaw.current_employees?.find(
            (emp) => emp.name === founder.value
          )?.image;

          nodes.push({
            id: founderId,
            name: founder.value,
            type: "founder",
            image: founderImage || "https://www.gravatar.com/avatar/?d=mp",
            size: 8,
            color: COLORS.founder,
          });
          links.push({
            source: company.uuid,
            target: founderId,
            type: "founder",
          });
        });
      }
    });
  }

  return { nodes, links };
}
